import axios from 'axios';
import { baseUrl } from '../settings';
import authHeader from './auth-header';

const API_URL = baseUrl + '/user/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'login', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        if(response.data.response.success === '1')
        {
          if (response.data.accessToken) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
          }
        }
        return response.data;
      });
  }

  loginWithProvider2(response) {
    console.log(response);
    return axios
      .post(API_URL + 'social/google', response)
      .then(response => {
        if(response.data.response.success === '1')
        {
          if (response.data.accessToken) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
          }
        }
        return response.data;
      });
  }

  loginWithProvider(response) {
    console.log('loginWithProvider_auth');
    var user = JSON.parse(response.user.replace(/&quot;/g,'"'));
    localStorage.setItem('user', user);
    localStorage.setItem('accessToken', JSON.stringify(response.accessToken));
    return response;
  }

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('processedImages');
    localStorage.removeItem('isSubscribed');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('clientDetails');
    localStorage.removeItem('referralDetails');
    localStorage.removeItem('userBillings');
    localStorage.removeItem('userLastNextPayments');
  }

  register(user) {
    return axios.post(API_URL + 'register', {
      email: user.email,
      password: user.password,
      updates: user.updates,
      locale: user.locale,
      timezone: user.timezone,
      ref_code: user.ref
    })
    .then(response => {
      if(response.data.response.success === '1')
      {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data.user));
          localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
        }
      }
      return response.data;
    });
  }

  forgotPassword(email) {
    return axios
      .post(API_URL + 'forgot-password', {
        email: email
      })
      .then(response => {
        return response;
      });
  }
  
  resetPassword(user) {
    return axios
      .post(API_URL + 'reset-password', {
        token: user.token,
        email: user.email,
        password: user.password,
        password_confirmation: user.confirmPassword
      })
      .then(response => {
        return response;
      });
  }

  isUserVerified() {
    return axios.post(API_URL + 'isUserVerified', null, { headers: authHeader() });
  }
}

export default new AuthService();